import type { SystemAlert } from '../../../types/trading';

const MARKET_STREAM_PREFIX = 'ibkr[';

export const isActionableOrderBlotterAlert = (alert: SystemAlert): boolean => {
  const level = (alert.level || '').trim().toLowerCase();
  if (level === 'error') {
    return true;
  }
  if (level !== 'warn') {
    return false;
  }

  const message = (alert.message || '').trim().toLowerCase();
  if (!message) {
    return false;
  }

  // Market stream reconnect/transport warnings are noisy in the blotter and
  // do not indicate an order action failure.
  if (message.startsWith(MARKET_STREAM_PREFIX)) {
    return false;
  }

  return true;
};
